angular.module('unergie.main')
.factory('AccountService', ($rootScope, DataAccess, DataAccessSearch, ErrorCatcher, MetaWatcher, AlertManager, BoFeaturesService) => {
    let account = null
    let customerId = null
    let contractId = null

    const reset = function () {
        account = null
        customerId = null
    }

    const watchers = {}

  // BO FEATURES
    const feats = BoFeaturesService.getModuleFeatures('accountinfo')
    const isAIFeatureOn = (feature) => feats[feature]

    const broadCast = function (acc, id_contract) {
        if (acc !== account) {
            account = acc
            return (() => {
                const result = []
                _.each(watchers, (callback) => {
                    result.push(callback(account, id_contract))
                })
                return result
            })()
        }
    }

    const watch = function (caller, callback) {
        watchers[caller] = callback
        return callback(account, contractId)
    }


    const fetchAccountById = (id, id_contract, callback) => {
        let acc
        return DataAccess.accountInfoLight({ id_account: id }).$promise.then((accountResult) => {
            acc = accountResult
            customerId = acc.customer_id
            if (acc && acc.billingaccount && isAIFeatureOn('accountBalances')) {
                return DataAccess.accountBalances({ id_account: id }).$promise.then((balances) => {
                    if (balances.toJSON) {
                        acc.balances = balances.toJSON()
                    }
                })
            }
        })
        .then(() => {
            broadCast(acc, id_contract)
            if (callback) {
                return callback(null, acc, id_contract)
            }
        })
    }


    const fetchAccount = function (customer_id, id_contract, callback) {
        customerId = customer_id
        account = null
        contractId = id_contract
        if (!customerId) {
            if (callback) {
                return callback('No customerId provided')
            }
            return console.log('No customerId provided')
        }
        return DataAccessSearch({}).search({ resource: 'accounts', customer_id }).$promise.then((searchResult) => {
            if (searchResult.length > 0) {
                const { id } = searchResult[0]
                return fetchAccountById(id, contractId, callback)
            }
            AlertManager.error(`Le compte recherché n'existe pas.`)
        }).catch((err) => {
            ErrorCatcher(err)
            if (callback) {
                return callback(err)
            }
        })
    }

    const fetchAccountForContract = function (id_contract, callback) {
        account = null
        contractId = id_contract
        if (!contractId) {
            return callback('No contractId provided')
        }
        return DataAccess.accountForContract({ id_contract: contractId }).$promise.then((accountResult) => {
            const { id } = accountResult
            return fetchAccountById(id, contractId, callback)
        }).catch((err) => {
            ErrorCatcher(err)
            if (callback) {
                return callback(err)
            }
        })
    }

    const getAccount = () => account

    const getCustomerId = () => customerId

    const refresh = () => fetchAccount(customerId, contractId)

    MetaWatcher.watch('ACCOUNT_CHANGED', 'AccountService', undefined, refresh)

    return {
        fetchAccount,
        fetchAccountById,
        fetchAccountForContract,
        reset,
        getAccount,
        getCustomerId,
        watch,
        refresh,
    }
})
